require 'backbone'

Backbone.Enhanced = {}
require './enhanced/utilities/object_has_attributes'
require './enhanced/events'
require './enhanced/model'
require './enhanced/view'

module.exports = Backbone.Enhanced